import { createActions } from 'reflux';

const SettingsActions = createActions([
  'getLocation',
  'set'
]);

export default SettingsActions;




// WEBPACK FOOTER //
// ./src/components/weather/weather_actions.js